export default state => state.savedItems.sdkFailure;
